import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Checkbox } from 'semantic-ui-react';
import config from '../../config';

import './PlotSettings.css';

export default function PlotSettings({
  availableColors, ecsSuitIsActive, handleEcsSuitChange, setSafetyHR,
  safetyHR, setYMin, setYMax, setTickCount, setChartWindow, startYMin,
  startYMax, startTickCount, startChartWindow, handleColorChange, selectedColor,
}) {
  const handleYMinChange = (e) => setYMin(parseInt(e.target.value, config.PARSE_INT_BASE));
  const handleYMaxChange = (e) => setYMax(parseInt(e.target.value, config.PARSE_INT_BASE));
  const handleTickCountChange = (e) => setTickCount(parseInt(e.target.value, config.PARSE_INT_BASE));
  const handleChartWindowChange = (e) => setChartWindow(parseInt(e.target.value, config.PARSE_INT_BASE));

  return (
    <Form className="plot-settings">
      <Form.Field label="Chart Settings" />

      {/* Y Axis */}
      <span>Y-Axis</span>
      <Form.Group>
        <Form.Field
          className="short"
          control={Input}
          label="Y-Min"
          name="ymin"
          onChange={handleYMinChange}
          type="number"
          value={startYMin}
        />
        <Form.Field
          className="short"
          control={Input}
          label="Y-Max"
          name="ymax"
          onChange={handleYMaxChange}
          type="number"
          value={startYMax}
        />
      </Form.Group>
      <Form.Group>
        <Form.Field
          control={Input}
          label="Y-Axis Tick Count"
          name="yAxisTicks"
          onChange={handleTickCountChange}
          type="number"
          value={startTickCount}
        />
      </Form.Group>

      {/* X Axis */}
      <span>X-Axis</span>
      <Form.Group>
        <Form.Field
          control={Input}
          label="Chart Window (min)"
          name="chartWindow"
          onChange={handleChartWindowChange}
          type="number"
          value={startChartWindow}
        />
      </Form.Group>

      {/* HR */}
      {(setSafetyHR)
        ? (
          <div>
            <span>HR</span>
            <Form.Group>
              <Form.Field
                className="short"
                control={Input}
                label="EV1 Safety HR (BPM)"
                name="safetyHREV1"
                onChange={(e) => setSafetyHR(e, 'EV1')}
                type="number"
                value={safetyHR.EV1}
              />
              <Form.Field
                className="short"
                control={Input}
                label="EV2 Safety HR (BPM)"
                name="safetyHREV2"
                onChange={(e) => setSafetyHR(e, 'EV2')}
                type="number"
                value={safetyHR.EV2}
              />
            </Form.Group>
          </div>
        ) : null}

      {/* ECS */}
      {(ecsSuitIsActive)
        ? (
          <div>
            <span>ECS Suit Toggles</span>
            {Object.keys(ecsSuitIsActive).map((key) => (
              <div key={key} className="flex-space-between">
                <span>
                  {key}
                  :
                </span>
                <Checkbox
                  toggle
                  checked={ecsSuitIsActive[key]}
                  onChange={() => handleEcsSuitChange(key)}
                />
              </div>
            ))}

            <div className="flex-space-between">
              <span>Select Color: </span>
              <select onChange={handleColorChange} defaultValue={selectedColor}>
                {availableColors.map((color) => (
                  <option key={color} value={color}>
                    {color}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ) : null}
    </Form>
  );
}

PlotSettings.propTypes = {
  setYMin: PropTypes.func,
  setYMax: PropTypes.func,
  setTickCount: PropTypes.func,
  setChartWindow: PropTypes.func,
  startYMin: PropTypes.number,
  startYMax: PropTypes.number,
  startTickCount: PropTypes.number,
  startChartWindow: PropTypes.number,
  setSafetyHR: PropTypes.func,
  safetyHR: PropTypes.any,
  availableColors: PropTypes.arrayOf(PropTypes.string),
  ecsSuitIsActive: PropTypes.objectOf(PropTypes.bool),
  selectedColor: PropTypes.string,
  handleEcsSuitChange: PropTypes.func,
  handleColorChange: PropTypes.func,
};
